export interface Country {
  name: string;
  code: string;
  flagUrl?: string;
}

export const UEMOA_COUNTRIES: Country[] = [
  { name: 'Bénin', code: 'BJ', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BJ.svg' },
  { name: 'Burkina Faso', code: 'BF', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/BF.svg' },
  { name: 'Côte d\'Ivoire', code: 'CI', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/CI.svg' },
  { name: 'Guinée-Bissau', code: 'GW', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GW.svg' },
  { name: 'Mali', code: 'ML', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/ML.svg' },
  { name: 'Niger', code: 'NE', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/NE.svg' },
  { name: 'Sénégal', code: 'SN', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/SN.svg' },
  { name: 'Togo', code: 'TG', flagUrl: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/TG.svg' }
];
